var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { ModalcloseReason } from 'hsg';
import { AuthBaseComponent } from '../auth-base/auth-base.component';
var AuthOpenCallsComponent = /** @class */ (function (_super) {
    __extends(AuthOpenCallsComponent, _super);
    function AuthOpenCallsComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuthOpenCallsComponent.prototype.ngOnInit = function () {
        this.authUserService.sendAuthData("ElasticLogger", { elasticCode: '2180' })
            .subscribe(function (res) { return console.log("sent elasticLog code:2180 - open window", res); }, function (error) { return console.log("sent elasticLog - open window error!", error); });
        sessionStorage.setItem("currentWindow", "פנייה פתוחה");
        sessionStorage.setItem("elasticCode", "");
    };
    AuthOpenCallsComponent.prototype.closeOpenCalls = function (shouldClose) {
        this.serverError = null;
        // this.authUserService.sendAuthData("CloseOpenCalls", { closeOpenCalls: shouldClose })
        // .subscribe((res: AuthenticationResult) => this.modalService.close({ redirect: true }, ModalcloseReason.action));
        this.authUserService.sendAuthData("CloseOpenCalls", { closeOpenCalls: shouldClose }).subscribe();
        this.modalService.close({ redirect: true }, ModalcloseReason.action);
    };
    return AuthOpenCallsComponent;
}(AuthBaseComponent));
export { AuthOpenCallsComponent };
